import { render, staticRenderFns } from "./PricePostedUsaModificationPopover.vue?vue&type=template&id=34f130b1&scoped=true"
import script from "./PricePostedUsaModificationPopover.vue?vue&type=script&lang=js"
export * from "./PricePostedUsaModificationPopover.vue?vue&type=script&lang=js"
import style0 from "./PricePostedUsaModificationPopover.vue?vue&type=style&index=0&id=34f130b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f130b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f130b1')) {
      api.createRecord('34f130b1', component.options)
    } else {
      api.reload('34f130b1', component.options)
    }
    module.hot.accept("./PricePostedUsaModificationPopover.vue?vue&type=template&id=34f130b1&scoped=true", function () {
      api.rerender('34f130b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-posting/usa-pro/PricePostedUsaModificationPopover.vue"
export default component.exports